import { isOfType, PlannerValidation, ProductType } from '@inter-ikea-storageone/range';
// Validation rule to not put valet hanger on specific sliding doors
export class RestrictValetHangersInSlidingDoorsValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'RestrictValetHangersInSlidingDoorsValidation');
        this.coreApi = coreApi;
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const isValetHanger = isOfType([ProductType.PAX_VALET_HANGER]);
        const guestIsValetHanger = isValetHanger(snapActionCandidate.guest);
        const slidingDoorOnFrame = this.coreApi.entities.findEntityInHierarchyWithOneOfProductTypes(snapActionCandidate.host, [ProductType.PAX_SLIDING_DOOR_WITH_PANELS_ASM, ProductType.PAX_SLIDING_DOOR_REGULAR_ASM]);
        if (guestIsValetHanger && slidingDoorOnFrame) {
            return this.validationFail(`Sliding door ${slidingDoorOnFrame} does not allow valet hanger`);
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=RestrictValetHangersInSlidingDoorsValidation.js.map